export const mapaDependenciasPorDefecto = {
  plantas: {
    ancestros: ['tablas', 'naves', 'invernaderos', 'sitios'],
    claveRelacional: 'tablaID',
  },
  surcos: {
    ancestros: ['tablas', 'naves', 'invernaderos', 'sitios'],
    claveRelacional: 'tablaID',
  },
  tablas: {
    ancestros: ['naves', 'invernaderos', 'sitios'],
    claveRelacional: 'naveID',
  },
  secciones: {
    ancestros: ['naves', 'invernaderos', 'sitios'],
    claveRelacional: 'naveID',
  },
  trampas: {
    ancestros: ['naves', 'invernaderos', 'sitios'],
    claveRelacional: 'naveID',
  },
  naves: {
    ancestros: ['invernaderos', 'sitios'],
    claveRelacional: 'invernaderoID',
  },
  invernaderos: {
    ancestros: ['sitios'],
    claveRelacional: 'sitioID',
  },
};

export const mapaDependenciasCompacto = {
  plantas: {
    ancestros: ['tablas', 'naves', 'sitios'],
    claveRelacional: 'tablaID',
  },
  surcos: {
    ancestros: ['tablas', 'naves', 'sitios'],
    claveRelacional: 'tablaID',
  },
  tablas: {
    ancestros: ['naves', 'sitios'],
    claveRelacional: 'naveID',
  },
  naves: {
    ancestros: ['sitios'],
    claveRelacional: 'sitioID',
  },
};
